function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Vrstva_x0020_1"
}, /*#__PURE__*/React.createElement("metadata", {
  id: "CorelCorpID_0Corel-Layer"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FA0000",
  d: "M3.08 0l7.91 0 6.7 6.99 0 13.58c0,1.7 -1.38,3.08 -3.08,3.08l-11.53 0c-1.7,0 -3.08,-1.38 -3.08,-3.08l0 -17.49c0,-1.7 1.38,-3.08 3.08,-3.08z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "white",
  fillOpacity: 0.301961,
  points: "10.98,0 10.98,6.93 17.69,6.93 "
}), /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M12.94 12.66c-0.08,-0.06 -0.2,-0.06 -0.29,-0.02l-1.99 1 0 -0.72c0,-0.51 -0.4,-0.91 -0.91,-0.91l-4.24 0c-0.5,0 -0.91,0.4 -0.91,0.91l0 3.63c0,0.51 0.41,0.91 0.91,0.91l4.24 0c0.51,0 0.91,-0.4 0.91,-0.91l0 -0.72 1.99 1c0.15,0.07 0.33,0.01 0.41,-0.14 0.02,-0.04 0.03,-0.09 0.03,-0.14l0 -3.63c0,-0.11 -0.06,-0.21 -0.15,-0.26zm-5.31 3.29c-0.67,0 -1.21,-0.55 -1.21,-1.22 0,-0.67 0.54,-1.21 1.21,-1.21 0.67,0 1.21,0.54 1.21,1.21 0,0.67 -0.54,1.22 -1.21,1.22z"
}));

function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "382px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 17.69 23.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.b2ff266a.svg";
export { ForwardRef as ReactComponent };